import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import InquiryPortal from "./sections/InquiryPortal";
import VisitUsToday from "./sections/VisitUsToday";
import InquireForServices from "./sections/InquireForServices";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <InquiryPortal />
      <VisitUsToday />
      <InquireForServices />
      <Footer />
    </div>;
}